<template>
  <transition name="fade">
    <div
      v-show="visible"
      class="back-to-top"
      @click.stop="scrollToTop"
      :style="customStyle"
    >
      <!-- 允许外部自定义按钮内容 -->
      <slot>
        <span class="default-arrow">
           <img :src="`${imgbtn}`" alt="" class="default-arrow" 
                 />
                 </span>
      </slot>
    </div>
  </transition>
</template>

<script>
/**
 * 返回顶部组件 (Vue2 · H5优化版)
 * 功能：滚动超过指定阈值后，在底部显示按钮；点击后平滑回到顶部。
 */
export default {
  name: 'BackToTop',
  props: {
      imgbtn: String,
    // 滚动距离超过多少像素时显示按钮
    threshold: {
      type: Number,
      default: 200
    },
    // 按钮的固定定位位置，可透传覆盖默认样式
    fixedPosition: {
      type: Object,
      default: () => ({
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)' // 默认底部居中，可改为 right: 20px 等
      })
    }
  },
  data() {
    return {
      visible: false,        // 是否显示按钮
      scrollRAF: null        // requestAnimationFrame 句柄
    };
  },
  computed: {
    // 将传入的定位对象转换为内联样式
    customStyle() {
      return {
        bottom: this.fixedPosition.bottom,
        left: this.fixedPosition.left,
        right: this.fixedPosition.right,
        transform: this.fixedPosition.transform
      };
    }
  },
  mounted() {
    // 监听滚动事件，使用 passive 提升移动端性能
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // 立即执行一次，检查初始滚动位置
    this.handleScroll();
  },
  beforeDestroy() {
    // 移除监听并取消未执行的动画帧
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollRAF) {
      cancelAnimationFrame(this.scrollRAF);
      this.scrollRAF = null;
    }
  },
  methods: {
    // 滚动事件处理器（RAF节流）
    handleScroll() {
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
      }
      this.scrollRAF = requestAnimationFrame(this.checkScrollThreshold);
    },
    // 检查滚动距离并控制显示
    checkScrollThreshold() {
      // 兼容不同浏览器的滚动距离获取方式
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.visible = scrollTop > this.threshold;
      this.scrollRAF = null; // 重置句柄
    },
    // 平滑返回顶部
    scrollToTop() {
      // 使用原生平滑滚动，不支持 behavior 的浏览器会自动回退到瞬间滚动
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style scoped>
@keyframes butChange {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}
/* 基础样式 - 可通过覆盖或 props.fixedPosition 调整位置 */
.back-to-top {
  position: fixed;
  /* 默认值已在 props 中定义，此处作为后备 */
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 44px;          /* 适中的点击区域，符合手指触控 */
  height: 44px;
  
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
 
  transition: background-color 0.2s, opacity 0.3s;
  user-select: none;
  -webkit-tap-highlight-color: transparent; /* 去掉移动端点击高亮 */
}

.back-to-top:active {
  background-color: rgba(0, 0, 0, 0.85);
}

.default-arrow {
  font-size: 28px;
  line-height: 1;
  font-weight: bold;
  transform: translateY(-1px); /* 视觉微调 */
  width: 230px;
 
    animation: butChange 1s infinite;
}

/* 渐隐过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>